import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type RatedAgeOCRState = {
  // BackgroundJob ids for rated age OCR uploads still being watched.
  // RatedAgeOCRWatcher polls each one and removes it once it finishes.
  processingJobIds: number[];
};

const initialState: RatedAgeOCRState = {
  processingJobIds: [],
};

const ratedAgeOCRSlice = createSlice({
  name: "ratedAgeOCR",
  initialState,
  reducers: {
    addProcessingRatedAgeOCRJob: (state, action: PayloadAction<number>) => {
      if (!state.processingJobIds.includes(action.payload)) {
        state.processingJobIds.push(action.payload);
      }
    },
    removeProcessingRatedAgeOCRJob: (state, action: PayloadAction<number>) => {
      state.processingJobIds = state.processingJobIds.filter(
        (id) => id !== action.payload,
      );
    },
  },
});

export const { addProcessingRatedAgeOCRJob, removeProcessingRatedAgeOCRJob } =
  ratedAgeOCRSlice.actions;

export default ratedAgeOCRSlice.reducer;
